export function Forward(_ref) {
  var children = _ref.children;
  return children;
}